// Base URL of the sss-server API.
// In production (single Railway service) the API is same-origin, so this is "".
// In local dev, REACT_APP_API_URL (set in .env.development) points to :5000.
const API_URL = process.env.REACT_APP_API_URL || "";

async function handle(res, fallback) {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `${fallback} (${res.status})`);
  }
  return res.json();
}

async function get(path) {
  return handle(await fetch(`${API_URL}/api${path}`), "Request failed");
}

export const getSpotsFull = () => get("/spots-full");
export const getSpot = (spotID) => get(`/spots/${spotID}`);

export async function createSpot(payload) {
  const res = await fetch(`${API_URL}/api/spots`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handle(res, "Could not create spot");
}

export async function updateSpot(spotID, payload) {
  const res = await fetch(`${API_URL}/api/spots/${spotID}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handle(res, "Could not update spot");
}

export async function deleteSpot(spotID) {
  const res = await fetch(`${API_URL}/api/spots/${spotID}`, {
    method: "DELETE",
  });
  return handle(res, "Could not delete spot");
}

export async function deleteImage(imgID) {
  const res = await fetch(`${API_URL}/api/images/${imgID}`, {
    method: "DELETE",
  });
  return handle(res, "Could not delete photo");
}

export async function uploadImage(spotID, file) {
  const fd = new FormData();
  fd.append("spotID", spotID);
  fd.append("image", file);
  const res = await fetch(`${API_URL}/api/upload`, { method: "POST", body: fd });
  return handle(res, "Photo upload failed");
}

// Shared password gate for editing/deleting spots.
export const EDIT_PASSWORD = "petalgarden";
export function requirePassword(action = "continue") {
  const pw = window.prompt(`Enter the password to ${action}:`);
  if (pw === null) return false; // cancelled
  if (pw !== EDIT_PASSWORD) {
    alert("Incorrect password.");
    return false;
  }
  return true;
}

// Resolve an image URL. Stored image URLs are same-origin (/uploads/...),
// so in local dev we prefix the API origin; absolute URLs pass through.
export const imgSrc = (u) => (u && u.startsWith("/") ? `${API_URL}${u}` : u);

export default API_URL;
